import { ControlsContent } from "../../../ui/controls/content.js";
import { ControlsGroup } from "../../../ui/controls/group.js";
import { ControlsRoot } from "../../../ui/controls/root.js";
import { TooltipProvider } from "../../../ui/tooltip/provider.js";
import { LiveButton } from "../shared/components/buttons/live-button.js";
import { VolumePopover } from "./components/controls/volume-popover.js";
import { AudioPlayButton } from "./skins/shared/audio/play-button.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/minimal-live-audio/controls.tsx
/** @jsxImportSource react */
function MinimalLiveAudioControls() {
	return /* @__PURE__ */ jsx(ControlsRoot, {
		visibility: "always",
		children: /* @__PURE__ */ jsx(ControlsContent, {
			className: cn("audio-controls", "audio-controls-content"),
			children: /* @__PURE__ */ jsxs(TooltipProvider, { children: [
				/* @__PURE__ */ jsxs(ControlsGroup, {
					className: "audio-controls-start",
					children: [/* @__PURE__ */ jsx(AudioPlayButton, {}), /* @__PURE__ */ jsx(LiveButton, {})]
				}),
				/* @__PURE__ */ jsx("div", {
					"aria-hidden": "true",
					className: "audio-controls-spacer"
				}),
				/* @__PURE__ */ jsx(ControlsGroup, {
					className: "audio-controls-end",
					children: /* @__PURE__ */ jsx(VolumePopover, {
						boundary: "viewport",
						showTooltip: true,
						side: "left",
						orientation: "horizontal"
					})
				})
			] })
		})
	});
}
//#endregion
export { MinimalLiveAudioControls };

//# sourceMappingURL=controls.js.map